<template>
    <form :action="`${gateway_url}/paymentform/`" method="post" ref="form">
        <div v-for="(value, name) in fields" :key="name">
            <input v-if="name != 'gateway_url'" :name="name" :value="value" type="hidden">
        </div>
    </form>
</template>

<script>
    export default {
        data() {
            return {
                fields: this.$route.query,
                gateway_url: this.$route.query.gateway_url
            }
        },
        mounted() {
           this.$refs.form.submit();
        }
    }
</script>
